exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cb-widget{font-family:Roboto, sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}sup{line-height:0px}body{margin:0;line-height:1.5}\n", ""]);

// exports
